<template>
    <div v-if="active">
        <div class="modal" style="display: block;"  @click.self="modalClose()">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">確認</h5>
                    </div>
                    <div class="modal-body">
                        <label class="form-label">{{ message }}</label>
                        <input type="date" class="form-control" v-model="date" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" :disabled="!date" @click="setAnswer(date)">OK</button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="modalClose()">キャンセル</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop show" ></div>
    </div>
</template>

<script>
export default {
    name: 'DateInputModal',
    props: {
        message: String
    },
    data() {
        return {
            active: false,
            date: null,
            answer: null
        }
    },
    methods: {
        /**
         * モーダルを開き、OKで入力された日付(YYYY-MM-DD)をresolveする
         * キャンセル・モーダル外クリックの場合はrejectする
         */
        action(defaultDate) {
            this.date = defaultDate;
            this.modalOpen();
            return new Promise((resolve, reject) => {
                const unwatch = this.$watch('answer', newVal => {
                    resolve(newVal);
                    unwatch();
                    this.initAnswer();
                    unwatch2();
                    this.modalClose();
                });
                const unwatch2 = this.$watch('active', newVal => {
                    unwatch();
                    unwatch2();
                    reject('modal: closed');
                })
            });
        },
        initAnswer() {
            this.answer = null;
        },
        modalOpen() {
            this.active = true;
        },
        modalClose() {
            this.active = false;
        },
        setAnswer(value) {
            this.answer = value;
        }
    },
}
</script>
